import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { MemberNewsRequest } from './DTOs/member-news-request';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MemberNewsService {
    readonly relativeBase = "member-news/";

    constructor(private http: ApiClient) { }

    submitMemberNews(request: MemberNewsRequest) {
        return this.http.post(this.relativeBase + "submit", request);
    }
    uploadNewsFile(formData: FormData) {
        return this.http.post(this.relativeBase + "upload", formData);
    }
    getBPStatus(): Observable<boolean> {
        return this.http.get(this.relativeBase + "bp-status");
    }
}
